import { ratingService } from '../services/ratingService.js';
import { Toast } from './Toast.js';

export function createRatingSheet(movie, onRatingSubmitted) {
  const backdrop = document.createElement('div');
  backdrop.className = 'sheet-backdrop';

  const userRating = ratingService.getUserRating(movie.id) || 0;

  backdrop.innerHTML = `
    <div class="bottom-sheet" role="dialog" aria-modal="true">
      <div class="sheet-handle"></div>
      <div style="text-align: center; margin-bottom: var(--space-md);">
        <h3 style="font-size: 1.25rem; font-weight: 800; margin-bottom: 4px;">Rate this Movie</h3>
        <p style="color: var(--text-secondary); font-size: 0.88rem;">${movie.title} (${movie.year})</p>
        <p style="color: var(--accent-gold); font-size: 0.82rem; margin-top: 2px;">${movie.sinhalaTitle || ''}</p>
      </div>

      <div class="star-rating-row" id="star-selector">
        ${[1, 2, 3, 4, 5].map(star => `
          <button type="button" class="star-btn ${star <= userRating ? 'active' : ''}" data-star="${star}" aria-label="Rate ${star} star">
            ★
          </button>
        `).join('')}
      </div>

      <div style="text-align: center; margin-bottom: var(--space-lg);">
        <span id="rating-label" style="font-size: 0.9rem; color: var(--text-muted); font-weight: 600;">
          ${userRating > 0 ? `You rated this ${userRating} of 5 stars` : 'Tap a star to rate'}
        </span>
      </div>

      <div style="display: flex; gap: var(--space-sm);">
        <button id="close-sheet-btn" class="btn-secondary" style="flex: 1;">Cancel</button>
      </div>
    </div>
  `;

  const starBtns = backdrop.querySelectorAll('.star-btn');
  const ratingLabel = backdrop.querySelector('#rating-label');

  starBtns.forEach(btn => {
    btn.addEventListener('mouseenter', () => {
      const star = parseInt(btn.dataset.star, 10);
      highlightStars(star);
    });

    btn.addEventListener('click', async () => {
      const star = parseInt(btn.dataset.star, 10);
      const result = await ratingService.rateMovie(movie, star);
      
      Toast.show(
        result.isUpdate 
          ? `Updated your rating for ${movie.title} to ${star} stars!` 
          : `Thank you for rating ${movie.title} ${star} stars!`,
        'success'
      );

      if (onRatingSubmitted) {
        onRatingSubmitted(result);
      }
      close();
    });
  });

  const selectorRow = backdrop.querySelector('#star-selector');
  selectorRow.addEventListener('mouseleave', () => {
    const current = ratingService.getUserRating(movie.id) || 0;
    highlightStars(current);
  });

  function highlightStars(count) {
    starBtns.forEach(b => {
      const s = parseInt(b.dataset.star, 10);
      if (s <= count) {
        b.classList.add('active');
      } else {
        b.classList.remove('active');
      }
    });
    if (count > 0) {
      ratingLabel.textContent = `${count} of 5 stars`;
      ratingLabel.style.color = 'var(--accent-gold)';
    } else {
      ratingLabel.textContent = 'Tap a star to rate';
      ratingLabel.style.color = 'var(--text-muted)';
    }
  }

  function close() {
    backdrop.classList.remove('active');
    setTimeout(() => backdrop.remove(), 250);
  }

  backdrop.querySelector('#close-sheet-btn').addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  document.body.appendChild(backdrop);
  requestAnimationFrame(() => backdrop.classList.add('active'));
}
